import { render, staticRenderFns } from "./ProvidersEMPage.vue?vue&type=template&id=887609c2"
import script from "./ProvidersEMPage.vue?vue&type=script&lang=js"
export * from "./ProvidersEMPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports